import axios from "axios";
import type { AxiosResponse } from "axios";
import type { FhirResource } from "fhir/r4";

class FHIRProxyClient {
  accessToken: string;
  apiURL: string;

  constructor(accessToken: string, apiURL: string) {
    this.accessToken = accessToken;
    this.apiURL = apiURL;
  }

  /**
   * `TData` is an unchecked claim about the response, not validation.
   *
   * A non-matching `requestType` falls through the switch and resolves with the empty
   * `AxiosResponse` seeded below rather than throwing, so a typo'd verb yields
   * `response.status === undefined` instead of an error.
   */
  async send<TData = FhirResource>(
    requestType: string,
    endPoint: string,
    data?: FhirResource,
  ): Promise<AxiosResponse<TData>> {
    const requestHeaders = {
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    };

    const requestURL = this.apiURL + endPoint;
    let response: AxiosResponse<TData> = <AxiosResponse<TData>>{};
    switch (requestType) {
      case "get":
        response = await axios.get(requestURL, { headers: requestHeaders });
        break;
      case "delete":
        response = await axios.delete(requestURL, { headers: requestHeaders });
        break;
      case "post":
        response = await axios.post(requestURL, data, {
          headers: requestHeaders,
        });
        break;
      case "put":
        response = await axios.put(requestURL, data, {
          headers: requestHeaders,
        });
        break;
      case "patch":
        response = await axios.patch(requestURL, data, {
          headers: requestHeaders,
        });
        break;
      default:
        break;
    }

    return response;
  }
}

export default FHIRProxyClient;
